import React from "react";
import { Route, Redirect } from "react-router-dom";

/*
interface PrivateRouterProps extends RouteComponentProps<{}>{
    component: React.FunctionComponent | React.ComponentClass,
    exact: boolean,
    path: string,
}

: FunctionComponent<PrivateRouterProps & RouteProps>
*/
const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props => {
      if (!localStorage.getItem("Token")) {
        // not logged in so redirect to login page with the return url
        return (
          <Redirect to={{ pathname: "/", state: { from: props.location } }} />
        );
      }

      // authorised so return component
      return <Component/>;
    }}
  />
);

export default PrivateRoute;